import { Component } from '@angular/core';
import { FilterStaticBase } from '@portal/shared/ui/filter/src/lib/components/static-base';
import {
  FILTER_CONTENT_ITEM,
  ISelectInput,
  SearchOperator,
  SearchSelector,
} from '@portal/shared/ui/filter/src';
import { FrequencyTypes } from '../../../list/frequency.list';

@Component({
  selector: 'portal-filter-frequency',
  templateUrl: './frequency.component.html',
  providers: [
    {
      provide: FILTER_CONTENT_ITEM,
      useExisting: FilterFrequencyComponent,
    },
  ],
  standalone: false,
})
export class FilterFrequencyComponent extends FilterStaticBase {
  frequencyTypeList: ISelectInput[];
  serviceProviderText = $localize`Frequency`;

  constructor(frequencyTypes: FrequencyTypes) {
    super(SearchSelector.Frequency, frequencyTypes.list);
    this.frequencyTypeList = frequencyTypes.list;
  }

  onEntityRemoved(selectedEntity: ISelectInput): void {
    this.localPreSelectedEntities.delete(selectedEntity.id);
  }

  onEntityAdded(selectedEntity: ISelectInput): void {
    this.localPreSelectedEntities.set(selectedEntity.id, selectedEntity);
  }

  onSelectAll(): void {
    const paresStatesList = this.frequencyTypeList ?? [];
    Array.from(paresStatesList).forEach((val) => {
      this.localPreSelectedEntities.set(val.id, val);
    });
  }

  onFilterApplied(): void {
    this.updateEntities();
    const values: string[] = this.getValues();

    this.filterApplied.emit({
      key: this.searchSelector,
      operator: SearchOperator.In,
      value: Array.from(this.localPreSelectedEntities.values()),
      argument: `(${Array.from(values).join(',')})`,
    });

    this.updateText();
    this.itemToggled.emit();
  }

  removeAllEntities(): void {
    this.localPreSelectedEntities.clear();
    this.updateText();
  }

  updateText(): void {
    const values: string[] = this.getValues();
    const text = $localize`Frequency`;
    if (values.length) {
      this.serviceProviderText = `${text} (+${values.length})`;
    } else {
      this.serviceProviderText = text;
    }
  }
}
